<template>
    <div class="original-main" v-title="'原厂认证'" v-if="details">
        <p class="add-tips" v-if="details.authStatus >= 10">添加速派微信：“gongyesupai” 了解详情</p>
        <img class="img" :src="details.detailimgurl" alt="图片" />
        <div class="sticky-card">
            <h3>仅需三步，快速获取认证</h3>
            <div class="circle-box">
                <ul class="circle-list">
                    <li class="pass">
                        <div>
                            <span></span>
                        </div>
                        <p>在线报名</p>
                    </li>
                    <li :class="{'pass':details.authStatus>=10}">
                        <div><span></span></div>
                        <p>现场考试</p>
                    </li>
                    <li :class="{'pass':details.authStatus==20 || details.authStatus>=40}">
                        <div><span></span></div>
                        <p>原厂面试</p>
                    </li>
                </ul>
                <div class="progress"><span :style="{ width: wdh } "></span></div>
            </div>
            <div class="original-sign">
                <button v-if="typeof(details.authStatus) == 'object' && new Date(details.endtime.replace(/-/g,'/')).getTime() > new Date().getTime() && details.iscanexam || typeof(details.authStatus) == 'object' && details.iscanexam || details.authStatus == 0 && details.iscanexam" @click="immApply">立刻报名</button>
                <button v-else-if="typeof(details.authStatus) == 'object' && new Date(details.endtime.replace(/-/g,'/')).getTime() < new Date().getTime() && !details.iscanexam || typeof(details.authStatus) == 'object' && !details.iscanexam || details.authStatus == 0 && !details.iscanexam" class="bg9">立刻报名</button>

                <button v-if="details.authStatus == 10 && details.iscanexam" @click="immTest">立刻考试</button>
                <button v-else-if="details.authStatus == 10 && !details.iscanexam" class="bg9">立刻考试</button>

                <button v-if="details.authStatus == 20 && new Date(details.endtime.replace(/-/g,'/')).getTime() > new Date().getTime()" @click="immInterview">预约面试</button>
                <button v-else-if="details.authStatus == 20 && new Date(details.endtime.replace(/-/g,'/')).getTime() < new Date().getTime()" class="bg9">预约面试</button>

                <button v-if="details.authStatus == 40" class="bg9">已预约，等待面试</button>

                <button v-if="details.authStatus == 50" style="background: #76CC7C;">面试通过</button>
                <button v-if="details.authStatus == 60" class="bg9">面试未通过</button>

                <div class="no-test" v-if="details.authStatus == 30">
                    <span>考试未通过！</span>
                    <button @click="immTest" v-if="details.iscanexam">再次考试</button>
                    <button v-else class="bg9">再次考试</button>
                </div>
            </div>
        </div>
        <van-dialog 
            v-model="show"
            @confirm="getConfigDetails()"
        >
            <div class="apply-success">
                <div>
                    <h3>报名成功！<br/>添加速派客服了解更多详情</h3>
                    <div class="qr-code">
                        <img src="@/assets/certification/qr-code.png" alt="二维码">
                    </div>
                    <p>微信号：gongyesupai</p>
                </div>
            </div>
        </van-dialog>
        <van-dialog 
            v-model="show2"
            @confirm="getConfigDetails()"
        >
            <div class="apply-success" style="padding: 0;">
                <div>
                    <h3>预约成功！<br/>请在近期留意手机电话</h3>
                </div>
            </div>
        </van-dialog>
        <div class="wx-mask" v-if="isShowWX" @click="isShowWX=false"></div>
    </div>
</template>
<script>
import {
    configDetails, //国家认证 || 原厂认证详情
    authApply,
    authInterview, //预约面试
} from '@/common/api.js'
import bridge from '@/common/dsbridge.js';
import { Dialog } from 'vant';
import {
    mapState
} from 'vuex'
let u = navigator.userAgent;
let ua = navigator.userAgent.toLowerCase();
export default {
    data(){
        return {
            show: false,
            show2: false,
            details: null,
            
            appUserInfo: null,              //app里的用户信息
            userid: Number,                 //app里的用户id 不带p
            isWeb: true,                    //是否是浏览器 true 是 false 否

            wdh: '18%',                        //width 



            isShowWX: false,

        }
    },
    computed: {
        ...mapState({
            userData: state => state.userData,
            createConfig: state => state.createConfig,
        }),
    },
    created() {
        this.isWeb=typeof(bridge.call('getUserInfo'))==='undefined'?true:false;
        this.getUserInfo()
    },
    mounted() {
        let self = this;
        bridge.register('notifyLoginSuccess', function () {
            self.getUserInfo();
        });
    },
    methods: {
        getUserInfo(){
            let info = bridge.call('getUserInfo') || null;
            if(info) {
                this.appUserInfo = JSON.parse(info);
                if (this.appUserInfo.userId.indexOf('p') === 0) {
                    this.userid = Number(this.appUserInfo.userId.substr(1));
                }
            }
            this.getConfigDetails()
        },
        // 获取原厂认证详情
        getConfigDetails(){
            let data = {}
            data.authConfigId = this.$route.query.id;
            data.authType = 2;
            if(this.appUserInfo && !this.isWeb) {
                data.nuserId = this.userid
                data.nuserType = 1;
            }else if(this.userData && this.isWeb) {
                data.nuserId = this.userData.UserId
                data.nuserType = 1;
            }
            configDetails(data).then(res=>{
                if(res.Result != 1) {
                    return this.$toast('请重新获取');
                }
                this.details = res.Data
                if(this.details.authStatus == 10 || this.details.authStatus == 30) {
                    this.wdh = '50%'
                }
                if(this.details.authStatus == 20 || this.details.authStatus >= 40) {
                    this.wdh = '82%'
                }
            })
        },
        // 点击立刻报名
        immApply(){
            if(!this.userData && this.isWeb) {
                return this.$router.push({ path: "/login/personLogin" });
            }
            this.getAuthApply()
        },
        // 获取payid
        getAuthApply(){
            let data = {}
            data.authConfigId = this.$route.query.id
            data.authStatus = 10
            if(this.appUserInfo && !this.isWeb) {
                data.nuserId = this.userid
            }else if(this.userData && this.isWeb) {
                data.nuserId = this.userData.UserId
            }
            data.nuserType = 1
            data.userCouponId = 0
            authApply(data).then(res=> {
                if(res.Result == 1) {
                    this.show = true
                }
            })
        },
        // 点击立即考试
        immTest(){
            if(!this.isWeb) {
                let r = {
                    authConfigId: this.$route.query.id,
                    residueDay: this.details.residueDay || 0,
                    authType: 2,
                    timelimit: this.details.timelimit || 0
                }
                bridge.call('goToExam',r)
            }else{
                this.openAPPTest()
            }
        },
        // 跳转到考试列表
        openAPPTest(){
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                this.isShowWX = true;
                return;
            }
            
            if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
                console.log('安卓');
                window.location.href = `gongkongsupai://com.gongkong.supai?launchType=12&authConfigId=${this.$route.query.id}&residueDay=${this.details.residueDay}&authType=2&timelimit=${this.details.timelimit}`;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    window.location.href = 'https://wx.insupai.com/download/download.html';
                    clearTimeout(this.timer);
                }, 3000);
            } else if (u.indexOf('iPhone') > -1) {
                console.log('苹果');
                window.location.href = `gongkongsupai://param?launchType=12&authConfigId=${this.$route.query.id}&residueDay=${this.details.residueDay}&authType=2&timelimit=${this.details.timelimit}`;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    window.location.href = 'https://wx.insupai.com/download/download.html';
                    clearTimeout(this.timer);
                }, 3000);
            }
        },

        // 点击预约面试
        immInterview(){
            if(!this.isWeb) {
                if(!this.appUserInfo.isengineer) {
                    Dialog.alert({
                        title: '提示',
                        message: '您还未成为工程师，请确认成为工程师',
                    }).then(() => {
                        bridge.call('jumpApplyEngineer')
                    });
                   return 
                }
                let data = {}
                data.authConfigId = this.$route.query.id
                if(this.appUserInfo && !this.isWeb) {
                    data.nuserId = this.userid
                }else if(this.userData && this.isWeb) {
                    data.nuserId = this.userData.UserId
                }
                data.nuserType = 1
                authInterview(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$notify(res.Message)
                    }
                    this.show2 = true
                })
            }else{
                console.log('跳转app')
            }
        },
        // 跳转app
        openAPP(){
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                this.isShowWX = true;
                return;
            }
            
            if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
                console.log('安卓');
                window.location.href = `gongkongsupai://com.gongkong.supai??launchType=3`;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    window.location.href = 'https://wx.insupai.com/download/download.html';
                    clearTimeout(this.timer);
                }, 3000);
            } else if (u.indexOf('iPhone') > -1) {
                console.log('苹果');
                window.location.href = `gongkongsupai://param?launchType=3`;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    window.location.href = 'https://wx.insupai.com/download/download.html';
                    clearTimeout(this.timer);
                }, 3000);
            }
        },
    }
}
</script>
<style lang="scss">
    @import '~@/style/_base.scss';
    .original-main {
        .add-tips {
            // position: sticky;
            // top: 0;
            height: px2rem(64px);
            background: rgba(247, 89, 89, .3);
            color: #f75959;
            font-size: px2rem(26px);
            line-height: px2rem(64px);
            padding: 0 px2rem(12px);
        }
        img.img {
            display: block;
            max-width: 100%;
            height: auto;
            object-fit: cover;
            min-height: 100vh;
        }
        .sticky-card {
            position: sticky;
            bottom: 0;
            padding-bottom: 20px;
            box-shadow: 0px -6px 10px 0px rgba(0, 0, 0, 0.06);
            padding-left: px2rem(28px);
            padding-right: px2rem(28px);
            min-height: px2rem(400px);
            background: #ffffff;
            h3 {
                font-size: px2rem(32px);
                color: #333333;
                font-weight: 500;
                line-height: px2rem(122px);
            }
            .circle-box {
                margin-top: px2rem(11px);
                margin-bottom: px2rem(11px);
                position: relative;
                .circle-list {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    position: relative;
                    z-index: 2;
                    li {
                        > div {
                            margin-bottom: px2rem(17px);
                            span {
                                display: block;
                                margin: 0 auto;
                                width: px2rem(40px);
                                height: px2rem(40px);
                                @include bg('~@/assets/certification/gary-circle.png');
                                background-position: center center;
                                background-size: px2rem(24px);
                            }
                        }
                        p {
                            font-size: px2rem(24px);
                            color: #999999;
                            font-style: italic;
                            margin-left: px2rem(-16px);
                        }
                    }
                    li.pass {
                        > div {
                            span {
                                @include bg('~@/assets/certification/red-circle.png');
                            }
                        }
                        p {
                            color: #f75959;
                        }
                    }
                }
                .progress {
                    width: 100%;
                    height: px2rem(6px);
                    background: #999999;
                    border-radius: px2rem(3px);
                    overflow: hidden;
                    position: absolute;
                    top: px2rem(18px);
                    span {
                        display: block;
                        // width: 18%;
                        // width: 50%;
                        // width: 82%;
                        height: inherit;
                        background: #f75959;
                    }
                }
            }
            .original-sign {
                padding: px2rem(48px) px2rem(22px) 0;
                > button {
                    display: block;
                    width: 100%;
                    height: px2rem(88px);
                    background: #f75959;
                    border-radius: px2rem(44px);
                    font-size: px2rem(30px);
                    color: #ffffff;
                }
                .no-test {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    span {
                        font-size: px2rem(28px);
                        font-weight: bold;
                        color: #F75959;
                    }
                    button {
                        width: px2rem(250px);
                        height: px2rem(80px);
                        text-align: center;
                        background: #f75959;
                        border-radius: px2rem(40px);
                        color: #ffffff;
                    }
                }
            }
        }
    }
    .apply-success {
        padding-top: px2rem(40px);
        min-height: px2rem(200px);
        display: flex;
        align-items: center;
        justify-content: center;
        h3 {
            text-align: center;
            font-size: px2rem(30px);
            font-weight: bold;
            color: #333333;
            line-height: px2rem(40px);
        }
        .qr-code {
            width: px2rem(190px);
            height: px2rem(190px);
            overflow: hidden;
            margin: px2rem(25px) auto 0;
            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        p {
            margin-bottom: px2rem(30px);
            color: #999999;
            font-size: px2rem(26px);
            line-height: px2rem(50px);
            text-align: center;
        }
    }
    .wx-mask {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background: url('~static/image/pointer.png');
        background-size: cover;
    }

    .bg9 {
        background: #999999 !important;
    }
</style>